document.addEventListener("DOMContentLoaded", function () {
	// Prevent default closing behavior
	document.addEventListener(
		"mousedown",
		function (e) {
			const openSubmenu = document.querySelector(
				'.wp-block-navigation-submenu__toggle[aria-expanded="true"]',
			);
			if (!openSubmenu) return;

			// Always prevent default closing behavior
			e.preventDefault();
			e.stopPropagation();
		},
		true,
	);

	// Handle submenu toggling
	document.addEventListener(
		"click",
		function (e) {
			const clickedToggle = e.target.closest(
				".wp-block-navigation-submenu__toggle",
			);
			if (!clickedToggle) return;

			// Get all open submenus except the one being clicked
			const openSubmenus = Array.from(
				document.querySelectorAll(
					'.wp-block-navigation-submenu__toggle[aria-expanded="true"]',
				),
			).filter((toggle) => toggle !== clickedToggle);

			// Close other open submenus
			openSubmenus.forEach((toggle) => {
				toggle.setAttribute("aria-expanded", "false");
			});
		},
		false,
	);
});
